import type { QuizType } from '@hooks/step-options/types'
import type { SelectOption } from '@ts-types/common/select/interfaces'

const optionYesEmpty: SelectOption = {
  id: 'yes',
  value: 'Yes',
  text: '',
  selected: false,
}
const optionNoEmpty: SelectOption = {
  id: 'no',
  value: 'No',
  text: '',
  selected: false,
}
const optionNotSure: SelectOption = {
  id: 'not-sure',
  value: 'Not sure yet',
  text: '',
  selected: false,
}

const defaultOptions: SelectOption[] = [
  optionYesEmpty,
  optionNoEmpty,
  optionNotSure,
]

export const answersWantAddEla = {
  yes: optionYesEmpty.value,
  no: optionNoEmpty.value,
  notSure: optionNotSure.value,
}

export const useOptionsWantAddEla = (quizType: QuizType): SelectOption[] => {
    const config: any = {
        'default': defaultOptions,
        'quiz15-after-school': defaultOptions,
    }
    return config[quizType]
}
